import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent, Observable, Subject, Subscription } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  skipWhile,
  take,
  tap,
} from 'rxjs/operators';
import moment from 'moment';
import 'moment-timezone';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';
import { createMask } from '@ngneat/input-mask';
import { get_sports_obj } from 'src/app/views/panda-connect/panda-connect.model';
import { PandaConnectBLL } from 'src/app/views/panda-connect/panda-connect.bll';
import { NewFieldEventBLL } from './new-field-event.bll';
import { LeaguesBLL } from 'src/app/views/leagues/leagues.bll';
import { field_event } from './model';
import { teaming_up_group } from 'src/app/components/events/new-activity/new-activity.model';
import { FieldSchedulesBLL } from '../field-schedules.bll';
import { FieldFacilityBLL } from '../../field-facility/field-facility.bll';
import { BusContactsBLL } from '../../bus-contacts/bus-contacts.bll';
import { ADContactsBLL } from '../../ad-contacts/ad-contacts.bll';
import { RefereeContactsBLL } from '../../referee-contacts/referee-contacts.bll';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ApiService } from 'src/app/services/api/api.service';
import { currentSportsBLL } from '../../settings/components/sports/components/current_sports/current_sports.bll';
import { EventStaffBLL } from '../../event-staff/event-staff.bll';
import { getRefereeStatus, RefereeStatus } from '../../assigner/schedule-listing/manage-referee/manage-referee.model';

@Component({
  selector: 'app-new-field-events',
  templateUrl: './new-field-events.page.html',
  styleUrls: ['./new-field-events.page.scss'],
})
export class NewFieldEventsPage implements OnInit {
  isOpenEarlyTime: boolean = false;
  auth$: Observable<AuthState>;
  current_user: any;
  schools$: Observable<any>;
  ad_contacts$: Observable<any>;
  referee_contacts$: Observable<any>;
  event_staff_contacts$: Observable<any>;
  bus_contacts$: Observable<any>;
  school: any;
  show_addNew$: Observable<boolean>;
  teams$: Observable<teaming_up_group[]>;
  opposing_teams$: Observable<teaming_up_group[]>;
  teaming_groups$: Observable<teaming_up_group[]>;
  sports$: Observable<get_sports_obj>;
  sportsLoading$: Observable<boolean>;
  field_facilities$: Observable<any>;
  edit_field_event_overlay: boolean = false;
  send_updates_to_referees?: boolean = false;
  send_updates_to_opposing_ad?: boolean = false;
  send_updates_to_bus_service?: boolean = false;
  send_updates_to_staff?: boolean = false;
  need_event_staff: boolean = false;

  //Loaders
  isLoading$: Observable<boolean>;
  isTeamsLoading$: Observable<boolean>;
  schoolsObservable$: Observable<any>;

  high_schools$: Observable<any>;
  is_high_school_loading$: Observable<boolean>;
  show_high_school_overlay: boolean = false;
  high_school_name_search: string = '';

  panda_clubs$: Observable<any>;
  is_club_loading$: Observable<boolean>;
  show_club_overlay: boolean = false;
  club_name_search: string = '';

  form: FormGroup;
  enable_notifications: boolean = true;
  show_teams_overlay: boolean = false;
  show_opposing_teams_overlay: boolean = false;
  team: any = null;
  @ViewChild('search_team') search_team: ElementRef;
  @ViewChild('search_opposing_teams') search_opposing_teams: ElementRef;
  selected_team: any = null;
  selected_opposing_team: any = null;

  // Multiple opposing ADs, each carrying the team that AD brings to the event.
  // Entry shape: { id, name, email, number, school, opposing_team_id, opposing_team_name }
  selectedOpposingAds: any[] = [];
  // Which AD row the opposing-team search overlay is currently editing
  activeOpposingAdIndex: number = -1;

  selected_schedule: any = null;
  openSource: string = '';

  leagues$: Observable<any>;
  league_schedules$: Observable<any>;
  leagueLoading: boolean = false;
  schedulesLoading: boolean = false;
  show_league: boolean = false;
  selected_league: any = null;

  selected_practice_id: string = null;
  practiceLoading$: Observable<boolean>;
  practice_enable_notifications: boolean = true;
  practice_start_date_picker: string = moment(new Date()).format('YYYY-MM-DD');
  practice_end_date_picker: string = moment(new Date()).format('YYYY-MM-DD');
  practice_start_time_picker: string = moment().format('YYYY-MM-DDTHH:mm');
  practice_end_time_picker: string = moment()
    .add(1, 'hour')
    .format('YYYY-MM-DDTHH:mm');
  practice_show_weekdays: boolean = false;
  for_referee: boolean = true;
  practiceSelectedWeekdays = [
    { title: 'Sun', value: 0, selected: true, show: true },
    { title: 'Mon', value: 1, selected: true, show: true },
    { title: 'Tue', value: 2, selected: true, show: true },
    { title: 'Wed', value: 3, selected: true, show: true },
    { title: 'Thu', value: 4, selected: true, show: true },
    { title: 'Fri', value: 5, selected: true, show: true },
    { title: 'Sat', value: 6, selected: true, show: true },
  ];

  date_picker: string = moment(new Date()).format('YYYY-MM-DD');

  start_time_picker: string = moment().format('YYYY-MM-DDTHH:mm');
  end_time_picker: string = moment(this.start_time_picker)
    .add(1, 'hour')
    .format('YYYY-MM-DDTHH:mm');
  early_time_picker: string = null;
  report_time_picker: string = null;

  departure_time_picker: string = moment(this.start_time_picker)
    .add(1, 'hour')
    .format('YYYY-MM-DDTHH:mm');
  return_time_picker: string = moment(this.start_time_picker)
    .add(3, 'hour')
    .format('YYYY-MM-DDTHH:mm');

  ad_admin_id = localStorage.getItem('ad_admin_id');
  ad_admin_email = localStorage.getItem('ad_admin_email');
  selectedAccount = localStorage.getItem('selected_account');

  schoolsSubscription: Subscription;
  sportsSubscription: Subscription;
  fieldsSubscription: Subscription;
  adContactsSubscription: Subscription;
  busContactsSubscription: Subscription;

  customSportAlertOptions = {
    header: 'Select Sport',
    message: 'Select One',
    translucent: true,
  };

  customSportAlertFacilityOptions = {
    header: 'Select Facility Field',
    message: 'Select One',
    translucent: true,
  };

  customSportAlertSchoolsOptions = {
    header: 'Select School or Club',
    message: 'Select One',
    translucent: true,
  };

  customSportAlertADOptions = {
    header: 'Select Opposing AD',
    message: 'Select One',
    translucent: true,
  };

  customSportAlertBusServiceOptions = {
    header: 'Select Bus Service',
    message: 'Select One',
    translucent: true,
  };

  customAlertRefereeOptions = {
    header: 'Select Referee',
    message: 'Select One',
    translucent: true,
  };

  customAlertEventStaffOptions = {
    header: 'Select Event Staff',
    message: 'Select One',
    translucent: true,
  };

  customAlertLeagueOptions = {
    header: 'Select League',
    message: 'Select One',
    translucent: true,
  };

  customAlertLeagueScheduleOptions = {
    header: 'Select League Schedule',
    message: 'Select One',
    translucent: true,
  };

  constructor(
    private bll: NewFieldEventBLL,
    private fb: FormBuilder,
    private toast: ToastController,
    private connectBll: PandaConnectBLL,
    private fieldSchedulesBLL: FieldSchedulesBLL,
    private fieldFacilityBLL: FieldFacilityBLL,
    private leaguesBLL: LeaguesBLL,
    private busContactsBLL: BusContactsBLL,
    private adContactsBll: ADContactsBLL,
    private refereeContactBll: RefereeContactsBLL,
    private eventStaffContactBll: EventStaffBLL,
    private auth: AuthService,
    private api: ApiService,
    private currentSportsBLL: currentSportsBLL
  ) {
    this.form = this.fb.group(this.initialize_form());

    this.fieldFacilityBLL.selectedFacility$
      .pipe(skipWhile((val) => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_facilities(id);
        }
      });

    this.bll.selectedFacility$
      .pipe(skipWhile((val) => !val))
      .subscribe((facility) => {
        if (facility.id) {
          this.field_facility.setValue(facility);
        }
      });

    this.busContactsBLL.selectedBuses$
      .pipe(skipWhile((val) => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_bus_contacts(id);
        }
      });

    this.bll.selectedBuses$
      .pipe(skipWhile((val) => !val))
      .subscribe((contact) => {
        this.addBusService(contact);
      });

    this.adContactsBll.selectedAd$
      .pipe(skipWhile((val) => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_ad_contacts(id);
        }
      });

    this.bll.selectedAD$.pipe(skipWhile((val) => !val)).subscribe((contact) => {
      this.addOpposingAd(contact);
    });

    this.refereeContactBll.selectedReferees$
      .pipe(skipWhile((val) => !val))
      .subscribe((id) => {
        if (id) {
          this.bll.get_referee_contacts(id);
        }
      });

    this.bll.selectedReferee$
      .pipe(skipWhile((val) => !val))
      .subscribe((contact) => {
        // A referee just created via "Add New" arrives here without
        // refs_needed, so default it to 1 like handleChangeReferee() does
        // for referees picked from the dropdown.
        contact.refs_needed = contact.refs_needed || 1;
        this.selectedReferees.push(contact);
        this.customAlertRefereeOptions.message = 'Add More Referee?';
      });

    this.eventStaffContactBll.selectedContact$
    .pipe(skipWhile((val) => !val))
    .subscribe((id) => {
      if (id) {
        this.bll.get_event_staff_contacts(id);
      }
    });

    this.bll.selectedEventStaff$
      .pipe(skipWhile((val) => !val))
      .subscribe((contact) => {
        this.selectedEventStaff.push(contact);
      });
  }

  ngAfterViewInit(): void {
    fromEvent(this.search_team.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(150),
        distinctUntilChanged(),
        tap((text) => {
          this.search_teaming_up_groups();
        }),
      )
      .subscribe();

    fromEvent(this.search_opposing_teams.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(150),
        distinctUntilChanged(),
        tap((text) => {
          this.search_opposing_teaming_up_groups();
        }),
      )
      .subscribe();
  }

  ngOnInit() {
    this.for_referee = true;
    this.form.get('for_referee')?.setValue(true);

    this.auth$ = this.auth.auth$;
    this.auth$
      .pipe(
        skipWhile((val) => !val.token),
        take(1),
      )
      .subscribe((auth) => {
        this.current_user = auth;
      });
    // Subscribe to open_source$ to track where the modal was opened from
    this.bll.open_source$.subscribe((source) => {
      this.openSource = source;
    });
    // this.reset_form_and_bll();
    this.mapObservables();
    this.fieldSchedulesBLL.selectedSchedule$.subscribe((schedule) => {
      if (schedule) {
        this.selected_schedule = schedule;

        // console.log('schedule:', schedule);
        this.sportsSubscription = this.connectBll.sports$.subscribe(
          (sports) => {
            if (schedule.sport_id) {
              let s_sport = sports?.sports.filter(
                (s) => s.id == schedule.sport_id,
              )[0];
              this.sport_json.setValue(s_sport);
            }
          },
        );

        this.fieldsSubscription = this.bll.field_facilities$.subscribe(
          (fields) => {
            if (schedule.field_id) {
              let s_field = fields.filter((f) => f.id == schedule.field_id)[0];
              this.field_facility.setValue(s_field);
            }
          },
        );

        this.adContactsSubscription = this.bll.ad_contacts$.subscribe((ad) => {
          // Events saved with the new multi-AD shape are populated in populateForm
          if (schedule.opposing_ads?.length) {
            return;
          }
          let target_id = schedule.opposing_ad_id || schedule.ad_admin_id;
          if (target_id) {
            let opposing_ad = ad.filter((f) => f.id == target_id)[0];
            if (opposing_ad) {
              this.addOpposingAd(opposing_ad, {
                id: schedule.opposing_teaming_up_id || schedule.opposing_team_id || null,
                title:
                  schedule.opposing_team_title || schedule.opposing_team_name || '',
              });
            } else if (schedule.ad_admin_id) {
              // Inject if not found
              this.bll.add_ad_contact_locally({
                id: schedule.ad_admin_id,
                name: schedule.ad_admin_name,
                email: schedule.ad_admin_email,
                number:
                  schedule.ad_admin_mobile || schedule.opposing_ad_mobile || '',
              });
            }
          }
        });

        // Support both `date_of_game_event` (field events) and `date` (pending schedule from league scheduler)
        const eventDate = schedule?.date_of_game_event || schedule?.date;
        if (eventDate) {
          const date = moment(eventDate).format('YYYY-MM-DD');
          this.date_picker = date;

          const start = schedule?.start_time;
          const end = schedule?.end_time;
          const early = schedule?.early_time;
          const report_time = schedule?.report_time;
          const departure = schedule?.departure;
          const return_time = schedule?.return_time;

          // Start Time
          if (start) {
            let sh = moment(start).format('HH');
            let sm = moment(start).format('mm');
            let current_start = `${date}T${sh}:${sm}`;
            const startMoment = moment(current_start);
            this.start.setValue(startMoment.toDate());
            this.start_time_picker = startMoment.format('YYYY-MM-DDTHH:mm');
          }

          // End Time
          if (end) {
            let endh = moment(end).format('HH');
            let endm = moment(end).format('mm');
            let current_end = `${date}T${endh}:${endm}`;
            const endMoment = moment(current_end);
            this.end.setValue(endMoment.toDate());
            this.end_time_picker = endMoment.format('YYYY-MM-DDTHH:mm');
          }

          // Early Time
          if (early) {
            let eh = moment(early).format('HH');
            let em = moment(early).format('mm');
            let current_early = `${date}T${eh}:${em}`;
            const earlyMoment = moment(current_early);
            this.early.setValue(earlyMoment.toDate());
            this.early_time_picker = earlyMoment.format('YYYY-MM-DDTHH:mm');
          }

          if (report_time) {
            let rh = moment(report_time).format('HH');
            let rm = moment(report_time).format('mm');
            let current_report_time = `${date}T${rh}:${rm}`;
            const reportMoment = moment(current_report_time);
            this.report_time.setValue(reportMoment.toDate());
            this.report_time_picker = reportMoment.format('YYYY-MM-DDTHH:mm');
          }

          // Departure Time
          if (departure) {
            let dh = moment(departure).format('HH');
            let dm = moment(departure).format('mm');
            let current_dep = `${date}T${dh}:${dm}`;
            const departureMoment = moment(current_dep);
            this.departure.setValue(departureMoment.toDate());
            this.departure_time_picker =
              departureMoment.format('YYYY-MM-DDTHH:mm');
          }

          //  Return Time
          if (return_time) {
            let rh = moment(return_time).format('HH');
            let rm = moment(return_time).format('mm');
            let current_return = `${date}T${rh}:${rm}`;
            const returnMoment = moment(current_return);
            this.return_time.setValue(returnMoment.toDate());
            this.return_time_picker = returnMoment.format('YYYY-MM-DDTHH:mm');
          }

          this.date_picker = date;
          this.refresh_referee_availability();
        }

        if (this.selected_schedule?.id) {
          this.populateForm(schedule);
        }
      }
    });

    // Practice event subscriptions
    this.bll.practice_created$.pipe(skipWhile((v) => !v), take(1)).subscribe((res) => {
      this.bll.reset_practice_created();
      this.reset_form_and_bll();
    });

    this.bll.practice_updated$.pipe(skipWhile((v) => !v), take(1)).subscribe((res) => {
      this.bll.reset_practice_updated();
      this.reset_form_and_bll();
    });
  }

  selectEarlyTime() {
    this.isOpenEarlyTime = true;
  }

  isOpenReportTime = false;

  selectReportTime() {
    this.isOpenReportTime = true;
  }

  onEarlyTimePopoverClose() {
    this.isOpenEarlyTime = false;
  }

  onReportTimePopoverClose() {
    this.isOpenReportTime = false;
  }

  clearEarlyTime() {
    this.early.setValue(null);
    this.early_time_picker = null;
  }

  clearReportTime() {
    this.report_time.setValue(null);
    this.report_time_picker = null;
  }

  mapObservables() {
    this.schools$ = this.bll.schools$;
    this.panda_clubs$ = this.bll.panda_clubs$;
    this.is_club_loading$ = this.bll.is_panda_clubs_loading$;
    this.high_schools$ = this.currentSportsBLL.high_schools$;
    this.is_high_school_loading$ = this.currentSportsBLL.is_high_schools_loading$;
    this.ad_contacts$ = this.bll.ad_contacts$;
    this.referee_contacts$ = this.bll.referee_contacts$;
    this.event_staff_contacts$ = this.bll.event_staff_contacts$;
    this.field_facilities$ = this.bll.field_facilities$;

    this.bus_contacts$ = this.bll.bus_contacts$;
    this.sportsLoading$ = this.connectBll.sportsLoading$;
    this.sports$ = this.connectBll.sports$;
    this.show_addNew$ = this.bll.show_addMenu$;
    this.isLoading$ = this.bll.isLoading$;
    this.isTeamsLoading$ = this.bll.isTeamsLoading$;
    this.teams$ = this.bll.teams$;
    this.opposing_teams$ = this.bll.opposing_teams$;
    this.teaming_groups$ = this.bll.teaming_groups$;

    this.leagues$ = this.bll.leagues$;
    this.league_schedules$ = this.leaguesBLL.schedulerData$;
    this.practiceLoading$ = this.bll.practiceLoading$;

    this.bll.blocked_referees$.subscribe((blocked) => {
      const map: { [contact_id: string]: string } = {};
      for (const b of blocked || []) {
        map[b.referee_contact_id] = b.label || 'Unavailable';
      }
      this.blocked_referees = map;
    });

    this.auth$
      .pipe(
        skipWhile((val) => !val?.token),
        take(1),
      )
      .subscribe(() => {
        this.bll.get_assigned_leagues(
          this.selectedAccount == '2' ? this.ad_admin_id : null,
        );
      });
  }

  change_for_referees() {
    this.for_referee = !this.for_referee;
    this.form.get('for_referee')?.setValue(this.for_referee);

   if (this.for_referee) {
    this.selectedReferees.forEach((referee) => {
      referee.refs_needed = 1;
    });
  }
  }

  time_change(type: string, event: any) {
    if (!event.detail.value) {
      return;
    }

    const applyTime = (control: any) => {
      let h = moment(event.detail.value).format('HH');
      let m = moment(event.detail.value).format('mm');
      let current_d = moment(
        this.date_picker ? this.date_picker : this.start.value,
      ).format('YYYY-MM-DD');
      current_d = `${current_d}T${h}:${m}`;
      control.setValue(moment(current_d).toDate());
      return moment(current_d);
    };

    switch (type) {
      case 'start':
        const startMoment = applyTime(this.start);
        this.start_time_picker = startMoment.format('YYYY-MM-DDTHH:mm');

        if (moment(this.end.value).isSameOrBefore(startMoment, 'minutes')) {
          const newEnd = startMoment.clone().add(1, 'hour');
          this.end_time_picker = newEnd.format('YYYY-MM-DDTHH:mm');
          this.end.setValue(newEnd.toDate());
        }
        this.refresh_referee_availability();
        break;

      case 'end':
        const endMoment = applyTime(this.end);
        this.end_time_picker = endMoment.format('YYYY-MM-DDTHH:mm');
        this.refresh_referee_availability();
        break;

      case 'early':
        const earlyMoment = applyTime(this.early);
        this.early_time_picker = earlyMoment.format('YYYY-MM-DDTHH:mm');
        break;

      case 'report_time':
        const reportMoment = applyTime(this.report_time);
        this.report_time_picker = reportMoment.format('YYYY-MM-DDTHH:mm');
        break;
      case 'departure':
        const departureMoment = applyTime(this.departure);
        this.departure_time_picker = departureMoment.format('YYYY-MM-DDTHH:mm');
        break;

      case 'return_time':
        const returnMoment = applyTime(this.return_time);
        this.return_time_picker = returnMoment.format('YYYY-MM-DDTHH:mm');
        break;
    }
  }

  reset_form_and_bll() {
    this.show_league=false
    this.fieldSchedulesBLL.selectedSchedule$.next(null);
    this.bll.reset_teams_observable();
    this.bll.reset_event_created();
    this.form = this.fb.group(this.initialize_form());
    this.date_picker = moment(new Date()).format('YYYY-MM-DD');

    this.start_time_picker = moment().format('YYYY-MM-DDTHH:mm');

    // this.start.setValue(null)

    this.end_time_picker = moment(this.start_time_picker)
      .add(1, 'hour')
      .format('YYYY-MM-DDTHH:mm');
    // this.end.setValue(null);

    this.early_time_picker = null;
    this.report_time_picker = null;
    this.departure_time_picker = moment(this.start_time_picker)
      .add(1, 'hour')
      .format('YYYY-MM-DDTHH:mm');
    this.return_time_picker = moment(this.start_time_picker)
      .add(3, 'hour')
      .format('YYYY-MM-DDTHH:mm');
    this.early.setValue(null);
    this.report_time.setValue(null);

    this.selected_team = null;
    this.selected_opposing_team = null;
    this.selectedOpposingAds = [];
    this.activeOpposingAdIndex = -1;
    this.customSportAlertADOptions.message = 'Select One';
    this.selected_schedule = null;
    this.for_referee = true;
    this.form.get('for_referee')?.setValue(true);
    this.selectedReferees = [];
    this.selectedEventStaff = [];
    this.staffRoleEditMode = {};
    this.need_event_staff = false;
    this.selectedBuses = [];
    this.send_updates_to_opposing_ad = false;
    this.send_updates_to_referees = false;
    this.send_updates_to_bus_service = false;
    this.send_updates_to_staff = false;

    this.high_school_name_search = '';
    this.club_name_search = '';

    // Reset practice form
    this.selected_practice_id = null;
    this.bll.reset_practice_loading();
    this.practice_enable_notifications = true;
    this.practice_start_date_picker = moment(new Date()).format('YYYY-MM-DD');
    this.practice_end_date_picker = moment(new Date()).format('YYYY-MM-DD');
    this.practice_start_time_picker = moment().format('YYYY-MM-DDTHH:mm');
    this.practice_end_time_picker = moment()
      .add(1, 'hour')
      .format('YYYY-MM-DDTHH:mm');
    this.practice_show_weekdays = false;
    this.practiceSelectedWeekdays.forEach((w) => {
      w.selected = true;
      w.show = true;
    });

    this.fieldSchedulesBLL.reset_sessions();

    if (this.schoolsSubscription) {
      this.schoolsSubscription.unsubscribe();
      this.schoolsSubscription = null;
    }

    if (this.sportsSubscription) {
      this.sportsSubscription.unsubscribe();
      this.sportsSubscription = null;
    }

    if (this.fieldsSubscription) {
      this.fieldsSubscription.unsubscribe();
      this.fieldsSubscription = null;
    }

    if (this.adContactsSubscription) {
      this.adContactsSubscription.unsubscribe();
      this.adContactsSubscription = null;
    }

    if (this.busContactsSubscription) {
      this.busContactsSubscription.unsubscribe();
      this.busContactsSubscription = null;
    }

    // this.bll.reset_observables()

    // document.getElementById('club_resset_name').setAttribute('value', null);

    // this.high_school.setValue(null);
    // this.sport_json.setValue(null);
  }

  populateForm(eventData: any) {
    // Handle pending schedule data with home_school/away_school nested objects
    let homeSchool = eventData.home_school;
    let awaySchool = eventData.away_school;
    let homeTeamingUp = eventData.home_teaming_up;
    let awayTeamingUp = eventData.away_teaming_up;

    console.log('current user', this.current_user);

    if (homeSchool && homeSchool.ad_admin_email != this.current_user.email) {
      homeSchool = eventData.away_school;
      awaySchool = eventData.home_school;
      homeTeamingUp = eventData.away_teaming_up;
      awayTeamingUp = eventData.home_teaming_up;
      this.game_type.setValue('away');
    } else {
      this.game_type.setValue(eventData.game_type || 'home');
    }

    this.schoolsSubscription = this.bll.schools$.subscribe((clubs) => {
      if (homeSchool?.school_id) {
        let s_club = clubs.filter(
          (c) => c.high_schools_id == homeSchool?.school_id,
        )[0];
        this.high_school.setValue(s_club);
        this.club_name_search = s_club?.name || s_club?.school_name;
      } else if (!homeSchool) {
        // Regular field event or legacy structure
        if (eventData.your_club_id) {
          let s_club = clubs.filter((c) => c.id == eventData.your_club_id)[0];
          if (s_club) {
            this.high_school.setValue(s_club);
            this.club_name_search = s_club?.name || s_club?.school_name;
          } else if (eventData.club_name) {
            this.club_name_search = eventData.club_name;
            this.high_school.setValue({
              id: eventData.your_club_id,
              name: eventData.club_name,
            });

          }
        } else if (eventData.your_high_school_id || eventData.high_school_id) {
          const hs_id = eventData.your_high_school_id || eventData.high_school_id;
          const hs_name = eventData.high_school_name || eventData.school_name;
          if (hs_id) {
            const hs = { id: hs_id, name: hs_name };
            this.form.get('selected_high_school').setValue(hs);
            this.high_school_name_search = hs_name;
          }
        }
      }
    });

    // Check if this is pending schedule data (has home_school/away_school)
    if (homeSchool) {
      // Pending schedule: Use home_school data for "Your Team"
      // Only show team title if there's an actual teaming_up_id (real team selected)
      const homeTeamId = homeSchool.teaming_up_id || homeTeamingUp?.id;
      this.selected_team = {
        id: homeTeamId,
        // Only use teaming_up_title if there's a real team (teaming_up_id exists)
        title: homeTeamId
          ? homeSchool.teaming_up_title || homeTeamingUp?.title || ''
          : '',
      };
      this.teaming_up_group_id.setValue(this.selected_team);

      // Use away_school data for "Opposing Team" and AD info
      if (awaySchool) {
        // Only show team title if there's an actual teaming_up_id (real team selected)
        const awayTeamId = awaySchool.teaming_up_id || awayTeamingUp?.id;
        this.selected_opposing_team = {
          id: awayTeamId,
          // Only use teaming_up_title if there's a real team (teaming_up_id exists)
          title: awayTeamId
            ? awaySchool.teaming_up_title || awayTeamingUp?.title || ''
            : '',
        };
        this.opposing_teaming_up_group_id.setValue(this.selected_opposing_team);

        // Seed the multi-AD list with the away school's AD and their team
        if (awaySchool.ad_admin_id) {
          this.selectedOpposingAds = [
            {
              id: awaySchool.ad_admin_id,
              name: awaySchool.ad_admin_name || '',
              email: awaySchool.ad_admin_email || '',
              number: awaySchool.ad_admin_number || '',
              school: awaySchool.teaming_up_title || awayTeamingUp?.title || '',
              opposing_team_id: awayTeamId || null,
              opposing_team_name:
                awaySchool.teaming_up_title || awayTeamingUp?.title || '',
            },
          ];
          this.customSportAlertADOptions.message = 'Add More Opposing AD?';
        }

        // Also populate the legacy single-AD fields (first AD)
        this.ad_name?.setValue(awaySchool.ad_admin_name || '');
        this.ad_email?.setValue(awaySchool.ad_admin_email || '');
        this.ad_cell?.setValue(awaySchool.ad_admin_number || '');
        this.opposing_team?.setValue(
          awaySchool.teaming_up_title || awayTeamingUp?.title || '',
        );
      }
    } else if (eventData.opposing_ads?.length) {
      // Event saved with the new multi-AD shape
      this.selected_team = {
        id: eventData.teaming_up_id,
        title: eventData.assign_team_title
          ? eventData.assign_team_title
          : eventData.teaming_up_title,
      };
      this.teaming_up_group_id.setValue(this.selected_team);

      // Backend returns oldest first; the form displays latest first
      this.selectedOpposingAds = eventData.opposing_ads
        .map((a: any) => ({
          id: a.id,
          name: a.name || '',
          email: a.email || '',
          number: a.number || '',
          school: a.school || '',
          opposing_team_id: a.opposing_team_id || null,
          opposing_team_name: a.opposing_team_name || '',
        }))
        .reverse();
      this.customSportAlertADOptions.message = 'Add More Opposing AD?';
      this.sync_primary_opposing_ad_fields();
    } else {
      // Regular field event data structure (legacy)
      this.selected_team = {
        id: eventData.teaming_up_id,
        title: eventData.assign_team_title
          ? eventData.assign_team_title
          : eventData.teaming_up_title,
      };
      this.selected_opposing_team = {
        id: eventData.opposing_teaming_up_id,
        title: eventData.opposing_team_title
          ? eventData.opposing_team_title
          : eventData.opposing_team_name,
      };

      this.teaming_up_group_id.setValue(this.selected_team);
      this.opposing_teaming_up_group_id.setValue(this.selected_opposing_team);

      this.ad_name?.setValue(
        eventData.opposing_ad_name
          ? eventData.opposing_ad_name
          : eventData.ad_admin_name || '',
      );
      this.ad_email?.setValue(
        eventData.opposing_ad_email
          ? eventData.opposing_ad_email
          : eventData.ad_admin_email || '',
      );
      this.ad_cell?.setValue(eventData.opposing_ad_mobile || '');
      this.opposing_team?.setValue(eventData.opposing_team_name || '');
    }

    this.for_referee = eventData.for_referee ?? true;
    this.form.get('for_referee')?.setValue(this.for_referee);
    this.selectedReferees = eventData.referee_contacts || [];
    this.selectedEventStaff = eventData.event_staff_contacts || [];
    this.need_event_staff = this.selectedEventStaff.length > 0;
    this.governing_organization?.setValue(
      eventData.governing_organization || '',
    );

    this.field_address?.setValue(eventData.away_field_address || '');
    this.fees_referee?.setValue(eventData.fee_per_referee || null);
    // Events from before multiple bus services only carry the legacy single-bus fields
    this.selectedBuses = eventData.bus_services?.length
      ? eventData.bus_services.map((b) => ({ ...b }))
      : eventData.bus_contact_id
        ? [{
            id: eventData.bus_contact_id,
            name: eventData.bus_name,
            email: eventData.bus_email,
            number: eventData.bus_mobile,
            buses_needed: eventData.buses_needed || 1,
            is_bus_confirmed: eventData.is_bus_confirmed,
          }]
        : [];
    // this.game_type.setValue(eventData.game_type || 'home');
    this.change_type(eventData.field_event_type || 'game');

    this.form
      .get('need_game_contract')
      ?.setValue(!!eventData.need_game_contract);
    this.form
      .get('need_referees_assigned')
      ?.setValue(
        eventData.need_referees_assigned === 'true' ||
          eventData.need_referees_assigned === true,
      );
    this.form.get('bus')?.setValue(!!eventData.need_bus);
    const leagueId = eventData?.league_id || null;
    const leagueScheduleId = eventData?.league_scheduler_id || null;

    if (leagueId) {
      this.show_league = true;
      // Wait for leagues to load, then set selected_league and auto-set sport
      this.leagues$.pipe(
        skipWhile((leagues) => !leagues || leagues.length === 0),
        take(1),
      ).subscribe((leagues) => {
        this.selected_league = leagues?.find((l: any) => l.league_id === leagueId) || null;
        if (this.selected_league?.sport_name) {
          this.sports$.pipe(
            skipWhile((s) => !s?.sports?.length),
            take(1),
          ).subscribe((sportsObj) => {
            const match = sportsObj?.sports?.find(
              (s: any) => s.name?.toLowerCase() === this.selected_league.sport_name?.toLowerCase()
            );
            if (match) {
              this.sport_json.setValue(match);
            }
          });
        }
        setTimeout(() => {
          this.league_id.setValue(leagueId);
          this.form.get('league_id').setValidators([Validators.required]);
          this.form.get('league_id').updateValueAndValidity();
          this.form.get('league_schedule_id').setValidators([Validators.required]);
          this.form.get('league_schedule_id').updateValueAndValidity();
        });
      });

      // Load schedule options, then set league_schedule_id after another tick
      this.leaguesBLL.getAllLeagueScheduler(
        leagueId,
        this.selectedAccount == '2' ? this.ad_admin_id : null,
      );
      this.league_schedules$
        .pipe(
          skipWhile((res) => {
            const list = res?.league_scheduler || res;
            return !list || (Array.isArray(list) && list.length === 0);
          }),
          take(1),
        )
        .subscribe(() => {
          setTimeout(() => {
            this.league_schedule_id.setValue(leagueScheduleId);
            this.form.get('league_schedule_id').updateValueAndValidity();
          });
        });
    }
    this.form
      .get('description')
      ?.setValue(eventData.description || '');
    if (eventData?.event?.length > 0) {
      this.form.get('practice_title')?.setValue(eventData.event[0].title || '');
      this.form
        .get('description')
        ?.setValue(eventData.description || '');
      this.form
        .get('practice_start')
        ?.setValue(
          eventData.event[0].start
            ? moment(eventData.event[0].start).toDate()
            : null,
        );
      this.form
        .get('practice_end')
        ?.setValue(
          eventData.event[0].end
            ? moment(eventData.event[0].end).toDate()
            : null,
        );
      this.practice_start_date_picker = eventData.event[0].start
        ? moment(eventData.event[0].start).format('YYYY-MM-DD')
        : this.practice_start_date_picker;
      this.practice_end_date_picker = eventData.event[0].end
        ? moment(eventData.event[0].end).format('YYYY-MM-DD')
        : this.practice_end_date_picker;
      this.practice_start_time_picker = eventData.event[0].start
        ? moment(eventData.event[0].start).format('YYYY-MM-DDTHH:mm')
        : this.practice_start_time_picker;
      this.practice_end_time_picker = eventData.event[0].end
        ? moment(eventData.event[0].end).format('YYYY-MM-DDTHH:mm')
        : this.practice_end_time_picker;

      if (eventData.event[0].weekdays) {
        let weekdays = [];
        try {
          if (typeof eventData.event[0].weekdays === 'string') {
            if (eventData.event[0].weekdays.startsWith('[')) {
              weekdays = JSON.parse(eventData.event[0].weekdays);
            } else {
              weekdays = eventData.event[0].weekdays.split(',').map(Number);
            }
          } else if (Array.isArray(eventData.event[0].weekdays)) {
            weekdays = eventData.event[0].weekdays;
          }
        } catch (e) {
          console.error('Error parsing weekdays', e);
          weekdays = [];
        }

        this.practice_weekdays.setValue(weekdays.join(','));
        this.practiceSelectedWeekdays.forEach((w) => {
          w.selected = weekdays.includes(w.value);
        });
        this.practice_show_weekdays = true;
      } else {
        this.practice_show_weekdays = false;
      }

      this.selected_practice_id = eventData.event[0].id || null;
    }

  }

  initialize_form() {
    return {
      governing_organization: ['', [Validators.required]],
      high_school: [null], // Renamed to Club in UI
      selected_high_school: [null], // The new High School field
      sport_json: [null],
      opposing_ad: [null],
      referee: [null],
      for_referee: [true],
      event_staff: [null],
      teaming_up_group_id: [{}],
      opposing_teaming_up_group_id: [{}],

      field_facility: [''],
      field_address: [''],
      opposing_team: ['', [Validators.required]],
      ad_name: [''],
      ad_email: [''],
      ad_cell: [''],
      need_game_contract: [false],
      need_referees_assigned: [false],
      ref_org_name: [''],
      Ref_Org_email: [''],
      Ref_Org_mobile: [''],
      fees_referee: ['', [Validators.required]],
      bus: [false],
      keyword_team: [''], // searching teams
      keyword_opposing_team: [''], // searching teams

      bus_service: [null],
      type: ['game'],
      game_type: ['home'],
      start: [moment(new Date()).toDate()],
      end: [moment(new Date()).add(1, 'hour').toDate()],
      early: [null],
      report_time: [null],
      departure: [moment(new Date()).add(1, 'hour').toDate()],
      return_time: [moment(new Date()).add(3, 'hour').toDate()],

      // Practice form controls
      practice_title: ['', [Validators.required]],
      practice_description: [''],
      practice_weekdays: [''],
      practice_start: [moment(new Date()).toDate()],
      practice_end: [moment(new Date()).add(1, 'hour').toDate()],
      league_id: [null],
      league_schedule_id: [null],
      description: [''],
    };
  }

  close_add_menu() {
    this.reset_form_and_bll();
    this.bll.toggle_add_menu(false);
    this.show_league=false
    this.selected_league = null;
  }

  toggle_notification() {
    this.enable_notifications = !this.enable_notifications;
  }

  change_type(type: string) {
    this.type.setValue(type);
    if (type === 'game') {
      this.opposing_team.setValidators([Validators.required]);
    } else {
      this.opposing_team.clearValidators();
    }
    this.opposing_team.updateValueAndValidity();
    if(type === 'practice') {
      this.clearLeague()
      this.show_league = false;
     }
  }

  // Practice form getters
  handleLeagueChange(event: any) {
    const leagueId = event.detail.value;
    this.form.get('league_schedule_id').reset();
    if (leagueId) {
      this.form.get('league_schedule_id').setValidators([Validators.required]);
      this.leaguesBLL.getAllLeagueScheduler(
        leagueId,
        this.selectedAccount == '2' ? this.ad_admin_id : null,
      );
      // Track selected league and auto-set sport from it
      this.leagues$.pipe(take(1)).subscribe((leagues) => {
        this.selected_league = leagues?.find((l: any) => l.league_id === leagueId) || null;
        if (this.selected_league?.sport_name) {
          this.sports$.pipe(take(1)).subscribe((sportsObj) => {
            const match = sportsObj?.sports?.find(
              (s: any) => s.name?.toLowerCase() === this.selected_league.sport_name?.toLowerCase()
            );
            if (match) {
              this.sport_json.setValue(match);
            }
          });
        }
      });
    } else {
      this.form.get('league_schedule_id').clearValidators();
      this.selected_league = null;
    }
    this.form.get('league_schedule_id').updateValueAndValidity();
  }

  clearLeague() {
    this.form.get('league_id').reset();
    this.form.get('league_id').clearValidators();
    this.form.get('league_schedule_id').reset();
    this.form.get('league_schedule_id').clearValidators();
    this.form.get('league_schedule_id').updateValueAndValidity();
    this.sport_json.reset()
    this.selected_league = null;
  }

  onShowLeagueChange(event: any) {
    this.show_league = (event.target as HTMLInputElement).checked;
    if (!this.show_league) {
      this.clearLeague();
    }
  }

  get league_id() {
    return this.form.get('league_id');
  }

  get league_schedule_id() {
    return this.form.get('league_schedule_id');
  }

  get practice_title() {
    return this.form.get('practice_title');
  }
  get practice_description() {
    return this.form.get('practice_description');
  }
  get practice_weekdays() {
    return this.form.get('practice_weekdays');
  }
  get practice_start() {
    return this.form.get('practice_start');
  }
  get practice_end() {
    return this.form.get('practice_end');
  }

  get description() {
    return this.form.get('description');
  }

  // Practice date change
  practice_date_change(type: string, event: any) {
    let date_value = moment(event.target.value).format('YYYY-MM-DD');

    if (type === 'start') {
      let h = moment(this.practice_start.value).format('HH');
      let m = moment(this.practice_start.value).format('mm');
      let current_d = `${date_value}T${h}:${m}`;
      this.practice_start.setValue(moment(current_d).toDate());
      this.practice_start_date_picker = date_value;

      if (moment(this.practice_end_date_picker).isBefore(moment(date_value))) {
        this.practice_end_date_picker = date_value;
        let hh = moment(this.practice_end.value).format('HH');
        let mm = moment(this.practice_end.value).format('mm');
        let current_dd = `${date_value}T${hh}:${mm}`;
        this.practice_end.setValue(moment(current_dd).toDate());
      }
    } else {
      let hh = moment(this.practice_end.value).format('HH');
      let mm = moment(this.practice_end.value).format('mm');
      let current_dd = `${date_value}T${hh}:${mm}`;
      this.practice_end.setValue(moment(current_dd).toDate());
      this.practice_end_date_picker = date_value;
    }

    let start = moment(this.practice_start.value).startOf('day');
    let end = moment(this.practice_end.value).startOf('day');
    let difference = end.diff(start, 'days');

    this.practice_show_weekdays = false;
    for (let v of this.practiceSelectedWeekdays) {
      v.selected = false;
      v.show = false;
    }
    this.practice_weekdays.reset();

    if (difference > 0) {
      this.practice_show_weekdays = true;
      if (difference >= 7) {
        for (let w of this.practiceSelectedWeekdays) {
          w.show = true;
          w.selected = true;
        }
        this.practice_weekdays.setValue('0,1,2,3,4,5,6');
      } else {
        let wd: string[] = [];
        let init_date = moment(this.practice_start.value);
        for (let i = 0; i <= difference; i++) {
          wd.push(moment.weekdaysMin((init_date.day() + i) % 7));
        }
        for (let w of this.practiceSelectedWeekdays) {
          for (let v of wd) {
            // Need a tiny helper to map weekdaysMin (Su, Mo, etc) to practiceSelectedWeekdays or
            // just use the numeric values directly as in my earlier found logic
            const dayMinMap = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
            if (dayMinMap[w.value] === v) {
              w.show = true;
              w.selected = true;
            }
          }
        }
        let fw = [];
        for (let w of this.practiceSelectedWeekdays) {
          if (w.selected) {
            fw.push(w.value);
          }
        }
        this.practice_weekdays.setValue(fw.join(','));
      }
    } else {
      this.practice_show_weekdays = false;
      this.practice_weekdays.setValue('0,1,2,3,4,5,6');
    }
  }

  // Practice time change
  practice_time_change(type: string, event: any) {
    let dateStr = event.detail.value;
    let h = moment(dateStr).format('HH');
    let m = moment(dateStr).format('mm');

    if (type === 'start') {
      let current_d = moment(this.practice_start_date_picker).format(
        'YYYY-MM-DD',
      );
      current_d = `${current_d}T${h}:${m}`;
      this.practice_start.setValue(moment(current_d).toDate());
      this.practice_start_time_picker =
        moment(current_d).format('YYYY-MM-DDTHH:mm');

      if (
        moment(this.practice_end.value).isSameOrBefore(
          moment(current_d),
          'minutes',
        )
      ) {
        const newEnd = moment(current_d).add(1, 'hour');
        // If end time moves, it should probably still stay on the end date picker's date if they are different?
        // But usually start/end times refer to the daily slot.
        // Let's stick to the core logic of moving the time.
        let end_d = moment(this.practice_end_date_picker).format('YYYY-MM-DD');
        let new_end_str = `${end_d}T${newEnd.format('HH:mm')}`;
        this.practice_end_time_picker =
          moment(new_end_str).format('YYYY-MM-DDTHH:mm');
        this.practice_end.setValue(moment(new_end_str).toDate());
      }
    } else {
      let current_d = moment(this.practice_end_date_picker).format(
        'YYYY-MM-DD',
      );
      current_d = `${current_d}T${h}:${m}`;
      this.practice_end.setValue(moment(current_d).toDate());
      this.practice_end_time_picker =
        moment(current_d).format('YYYY-MM-DDTHH:mm');
    }
  }

  // Practice weekday selection
  selectPracticeWeekday(day: number) {
    let w = this.practiceSelectedWeekdays.find((d) => d.value === day);
    w.selected = !w.selected;
    let selected = this.practiceSelectedWeekdays
      .filter((d) => d.selected)
      .map((d) => d.value);
    this.practice_weekdays.setValue(selected.join(','));
  }

  // Create or update practice event
  async create_practice_event() {
    let data = this.form.value;
    let message = '';

    if (!data.high_school?.name && !data.selected_high_school?.name) {
      message = 'Please select a Club or High School.';
    } else if (!data.teaming_up_group_id?.id) {
      message = 'Please select your Team.';
    } else if (!data.practice_title) {
      message = 'Please enter a title for the practice session.';
    } else if (!data.sport_json?.id) {
      message = 'Please select the Sport.';
    } else if (!data.field_facility?.id) {
      message = 'Please select the Home Facility Field.';
    } else if (data.league_id && !data.league_schedule_id) {
      message = 'Please select a League Schedule.';
    } else if (this.bus.value && !this.selectedBuses.length) {
      message = 'Please select at least one Bus Service.';
    } else if (this.bus.value && this.selectedBuses.some((b) => !(b.buses_needed >= 1))) {
      message = 'Please enter the number of buses needed for each Bus Service.';
    } else if (this.need_event_staff && this.selectedEventStaff?.length > 0) {
      const missingRole = this.selectedEventStaff.some((s) => !s.staff_role?.trim());
      if (missingRole) {
        message = 'Please enter a role for each selected event staff member.';
      }
    }

    if (message) {
      const toast = await this.toast.create({
        message: message,
        buttons: [
          {
            role: 'cancel',
            text: 'Ok',
          },
        ],
        duration: 3000,
        color: 'danger',
        position: 'bottom',
      });
      await toast.present();
      return;
    }

    let time_checker_start =
      moment(this.practice_start.value).format('YYYY-MM-DD') +
      'T' +
      moment(this.practice_start.value).format('HH:mm:ss');
    let time_checker_end =
      moment(this.practice_start.value).format('YYYY-MM-DD') +
      'T' +
      moment(this.practice_end.value).format('HH:mm:ss');

    if (
      moment(this.practice_end.value).isSameOrBefore(
        this.practice_start.value,
        'minutes',
      ) ||
      moment(time_checker_end).isSameOrBefore(time_checker_start, 'minutes')
    ) {
      const t = await this.toast.create({
        message:
          'End time cannot be before start time. Please adjust and try again',
        buttons: [{ role: 'cancel', text: 'Ok' }],
        duration: 3000,
        color: 'warning',
        position: 'bottom',
      });
      await t.present();
      return;
    }

    // Build weekdays string
    let weekdaysValue = data.practice_weekdays;
    if (!weekdaysValue) {
      weekdaysValue = '0,1,2,3,4,5,6';
    }

    // Bus departure/return times (mirrors game's create_event)
    let departure_time_picker = moment(this.departure.value).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );
    let return_time_picker = moment(this.return_time.value).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );

    let practice_event = {
      title: data.practice_title,
      start: moment(this.practice_start.value).format('YYYY-MM-DDTHH:mm:ssZ'),
      end: moment(this.practice_end.value).format('YYYY-MM-DDTHH:mm:ssZ'),
      your_team_id: data.teaming_up_group_id?.id,
      teaming_up_group_id: data.teaming_up_group_id?.id,
      governing_organization: data.governing_organization,
      sport_id: data.sport_json?.id,
      field_event_type: 'practice',
      type: 'practice',
      weekdays: weekdaysValue,
      notify_member: this.practice_enable_notifications,
      game_type: 'home',
      your_club_id: data.high_school?.name ? data.high_school.id : null,
      club_name: data.high_school?.name || null,
      high_school_id: data.selected_high_school?.name ? data.selected_high_school.id : null,
      high_school_name: data.selected_high_school?.name || null,
      your_team_title: data.teaming_up_group_id.title,
      description: data.description,
      field_id: data.field_facility?.id,
      field_name: data.field_facility?.label,
      sport_name: data.sport_json?.name,
      league_id: data.league_id,
      league_schedule_id: data.league_schedule_id,
      id: this.selected_schedule?.id,
      home_event_id: this.selected_schedule?.home_event_id,
      // Contract links in staff/bus notification emails are built from this
      origin: window.location.origin,
      // Event staff (same shape game sends)
      event_staff_contacts: this.selectedEventStaff,
      // Bus service (mirrors game's create_event)
      need_bus: data.bus,
      ...this.busServicesPayload(data.bus),
      departure: data.bus ? departure_time_picker : null,
      return_time: data.bus ? return_time_picker : null,
      send_updates_to_staff: this.send_updates_to_staff,
      send_updates_to_bus_service: this.send_updates_to_bus_service,
    };

    const admin = this.selectedAccount == '2' ? { ad_admin_id: this.ad_admin_id, ad_admin_email: this.ad_admin_email } : null;

    // Close the "Send update to" overlay (opened only on practice update)
    this.edit_field_event_overlay = false;

    if (this.selected_schedule?.id) {
      this.bll.update_practice_event(practice_event, admin);
    } else {
      this.bll.create_practice_event(practice_event, admin);
    }
  }

  // search_teaming_up_groups() {
  //   this.bll.get_teaming_up_groups_by_search(this.keyword_team.value);
  // }

  search_teaming_up_groups() {
    this.selectedAccount = localStorage.getItem('selected_account');
    this.ad_admin_email = localStorage.getItem('ad_admin_email');
    this.ad_admin_id = localStorage.getItem('ad_admin_id');
    this.bll.get_teaming_up_groups(
      this.keyword_team.value,
      this.selectedAccount == '2'
        ? this.ad_admin_email
        : this.current_user.email,
    );
  }

  search_opposing_teaming_up_groups() {
    // Search within the teams of the AD whose row opened the overlay
    const active_ad = this.selectedOpposingAds[this.activeOpposingAdIndex];
    this.bll.get_opposing_teams(
      this.keyword_opposing_team.value,
      active_ad?.email || this.ad_email.value,
    );
  }

  // select_teaming_up_group(team: teaming_up_group) {
  //   if (team) {
  //     this.selected_team = team;
  //     this.teaming_up_group_id.setValue(this.selected_team);
  //   }
  //   this.show_teams_overlay = false;
  //   this.keyword_team.reset();
  //   this.bll.reset_teams_observable();
  // }

  select_teaming_up_group(teaming_groups: teaming_up_group) {
    if (teaming_groups) {
      this.selected_team = teaming_groups;
      this.teaming_up_group_id.setValue(this.selected_team);
    }
    this.show_teams_overlay = false;
    this.keyword_team.reset();
    this.bll.reset_teaming_groups_observable();
  }

  select_opposing_teaming_up_group(opposing_team: any) {
    const active_ad = this.selectedOpposingAds[this.activeOpposingAdIndex];
    if (opposing_team && active_ad) {
      active_ad.opposing_team_id = opposing_team.id || null;
      active_ad.opposing_team_name = opposing_team.title || '';
      active_ad.opposing_team_display_picture =
        opposing_team.display_picture || null;
      this.sync_primary_opposing_ad_fields();
    }
    this.show_opposing_teams_overlay = false;
    this.activeOpposingAdIndex = -1;
    this.keyword_opposing_team.reset();
    this.bll.reset_opposing_teams_observable();
  }

  startDateInputMask = createMask<Date>({
    alias: 'datetime',
    inputFormat: 'dd/mm/yyyy',
    parser: (value: string) => {
      const values = value.split('/');
      const year = +values[2];
      const month = +values[1] - 1;
      const date = +values[0];
      return new Date(year, month, date);
    },
  });

  endDateInputMask = createMask<Date>({
    alias: 'datetime',
    inputFormat: 'dd/mm/yyyy',
    parser: (value: string) => {
      const values = value.split('/');
      const year = +values[2];
      const month = +values[1] - 1;
      const date = +values[0];
      return new Date(year, month, date);
    },
  });

  date_change(event: any) {
    let date_value = moment(event.target.value).format('YYYY-MM-DD');
    this.date_picker = date_value;
    this.refresh_referee_availability();
  }

  open_edit_field_event_overlay() {
    this.edit_field_event_overlay = true;
  }

  // Practice update: if the practice has event staff and/or a bus, let the user
  // choose whom to notify via the shared "Send update to" overlay; otherwise save directly.
  handlePracticeUpdateClick() {
    const hasNotifiables =
      this.selectedEventStaff?.length > 0 || !!this.bus.value;
    if (hasNotifiables) {
      this.send_updates_to_staff = false;
      this.send_updates_to_bus_service = false;
      this.open_edit_field_event_overlay();
    } else {
      this.create_practice_event();
    }
  }

  // Confirm button inside the "Send update to" overlay — routes by activity type.
  confirmSendUpdates() {
    if (this.type.value === 'practice') {
      this.create_practice_event();
    } else {
      this.check_field_confilict();
    }
  }

  handleUpdateClick() {
    if (this.type.value === 'event') {
      this.check_field_confilict();
      return;
    }

    if (this.hasCoreEventDetailsChanged()) {
      this.send_updates_to_opposing_ad = true
      this.open_edit_field_event_overlay();
    } else {
      this.check_field_confilict();
    }
  }

  hasCoreEventDetailsChanged(): boolean {
    if (!this.selected_schedule) return true;

    const eventData = this.selected_schedule;
    const formRaw = this.form.getRawValue();

    const origDate = eventData.date_of_game_event || eventData.date;
    if (origDate && moment(origDate).format('YYYY-MM-DD') !== this.date_picker) return true;

    if (eventData.start_time) {
      let sh = moment(eventData.start_time).format('HH');
      let sm = moment(eventData.start_time).format('mm');
      let d = moment(origDate).format('YYYY-MM-DD');
      if (`${d}T${sh}:${sm}` !== this.start_time_picker) return true;
    }

    if (eventData.end_time) {
      let eh = moment(eventData.end_time).format('HH');
      let em = moment(eventData.end_time).format('mm');
      let d = moment(origDate).format('YYYY-MM-DD');
      if (`${d}T${eh}:${em}` !== this.end_time_picker) return true;
    }

    let expectedGameType = eventData.game_type || 'home';
    if (eventData.home_school && eventData.home_school.ad_admin_email != this.current_user?.email) {
      expectedGameType = 'away';
    }
    if (formRaw.game_type !== expectedGameType) return true;

    // if (formRaw.governing_organization !== (eventData.governing_organization || '')) return true;
    // if (formRaw.description !== (eventData.description || '')) return true;
    if (formRaw.field_address !== (eventData.away_field_address || '')) return true;
    
    if (formRaw.sport_json && formRaw.sport_json.id != eventData.sport_id) return true;
    if (formRaw.field_facility && formRaw.field_facility.id != eventData.field_id) return true;
    // if (formRaw.league_id != (eventData.league_id || null)) return true;
    // if (formRaw.league_schedule_id != (eventData.league_scheduler_id || null)) return true;
    // if (formRaw.type !== (eventData.field_event_type || 'game')) return true;

    let oppTeamName = '';
    if (eventData.home_school) {
      if (eventData.home_school.ad_admin_email != this.current_user?.email) {
         oppTeamName = eventData.home_school.teaming_up_title || eventData.home_teaming_up?.title || '';
      } else if (eventData.away_school) {
         oppTeamName = eventData.away_school.teaming_up_title || eventData.away_teaming_up?.title || '';
      }
    } else {
      oppTeamName = eventData.opposing_team_title || eventData.opposing_team_name || '';
    }
    // if (formRaw.opposing_team !== oppTeamName) return true;

    // Compare the full opposing AD set (multi-AD aware)
    let origAdIds: any[] = (eventData.opposing_ads || []).map((a: any) => a.id);
    if (origAdIds.length === 0) {
      let origAdId = eventData.opposing_ad_id || eventData.ad_admin_id;
      if (eventData.home_school) {
        if (eventData.home_school.ad_admin_email != this.current_user?.email) {
          origAdId = eventData.home_school.ad_admin_id;
        } else if (eventData.away_school) {
          origAdId = eventData.away_school.ad_admin_id;
        }
      }
      origAdIds = origAdId ? [origAdId] : [];
    }
    const currentAdIds = this.selectedOpposingAds.map((a) => a.id);
    if (
      origAdIds.length !== currentAdIds.length ||
      currentAdIds.some((id) => !origAdIds.includes(id))
    ) {
      return true;
    }

    let origClubId = eventData.your_club_id;
    if (eventData.home_school) {
      if (eventData.home_school.ad_admin_email != this.current_user?.email) {
         origClubId = eventData.away_school?.school_id;
      } else {
         origClubId = eventData.home_school?.school_id;
      }
    }
    // if (formRaw.high_school && formRaw.high_school.id != origClubId) return true;

    return false;
  }

  isLoading = false;

  check_field_confilict(admin = null) {
    let data = this.form.value;

    let d = moment(this.date_picker).format('YYYY-MM-DD');
    let current = `${d}T12:00`;
    const date_with_time_to_save = moment(current).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );

    let body = {
      field_id: data.field_facility?.id,
      // Don't send id for pending schedule items since selected_schedule.id is a league_scheduler_event_id, not a field_event id
      id:
        this.openSource === 'from-pending' ? null : this.selected_schedule?.id,
      end_time: moment(this.end.value).format('YYYY-MM-DDTHH:mm:ssZ'),
      start_time: moment(this.start.value).format('YYYY-MM-DDTHH:mm:ssZ'),
      date_of_game_event: date_with_time_to_save,
    };

    let url = `field-events?type=field_event_conflict`;

    if (admin?.ad_admin_id) {
      url += `&admin_id=${admin.ad_admin_id}`;
    }

    if (admin?.ad_admin_email) {
      url += `&admin_email=${admin.ad_admin_email}`;
    }

    this.api
      .patch(url, body)
      .pipe(take(1))
      .subscribe(
        async (res: any) => {
          this.create_event();
        },
        async (err) => {
          this.isLoading = false;
          if (err?.status === 409) {
            const t = await this.toast.create({
              header: 'Error',
              message: `There is another event already scheduled on this field from ${moment(err.error?.data?.start_time).format('HH:mm a')} to ${moment(err.error?.data?.end_time).format('HH:mm a')}.`,
              duration: 5000,
              color: 'danger',
            });
            await t.present();
            return;
          }

          const t = await this.toast.create({
            header: 'Error',
            message: `There was an issue creating this event. Please try again.`,
            duration: 5000,
            color: 'danger',
          });

          await t.present();
        },
      );
  }

  async create_event() {
    let data = this.form.value;

    let message = '';

    if (!data.high_school?.name && !data.selected_high_school?.name) {
      message = 'Please select a Club or High School.';
    } else if (!data.teaming_up_group_id?.id) {
      message = 'Please select your Team.';
    } else if (data.need_game_contract && !data.governing_organization) {
      message =
        'If you need a game contract, Governing Organization is required.';
    } else if (!data.sport_json?.id) {
      message = 'Please select the Sport.';
    } else if (data.game_type == 'home' && !data.field_facility?.id) {
      message = 'Please select the Home Facility Field.';
    }
    //  else if (data.game_type == 'away' && !data.field_address) {
    //   message = 'Away Field Address is required.'
    // }
    else if (data.type !== 'event' && this.selectedOpposingAds.length === 0) {
      message = 'Please select at least one Opposing AD.';
    } else if (
      data.type !== 'event' &&
      this.selectedOpposingAds.some((a) => !a.opposing_team_name)
    ) {
      message = 'Please select an Opposing Team for each Opposing AD.';
    } else if (
      data.need_referees_assigned &&
      this.selectedReferees?.length < 1
    ) {
      message = 'Please select Select at least one referee.';
    } else if (data.need_referees_assigned && !data.fees_referee) {
      message = 'Referee Fee is required.';
    } else if (this.bus.value && !this.selectedBuses.length) {
      message = 'Please select at least one Bus Service.';
    } else if (this.bus.value && this.selectedBuses.some((b) => !(b.buses_needed >= 1))) {
      message = 'Please enter the number of buses needed for each Bus Service.';
    } else if (this.need_event_staff && this.selectedEventStaff?.length > 0) {
      const missingRole = this.selectedEventStaff.some((s) => !s.staff_role?.trim());
      if (missingRole) {
        message = 'Please enter a role for each selected event staff member.';
      }
    }

    if (message) {
      const toast = await this.toast.create({
        message: message,
        buttons: [
          {
            role: 'cancel',
            text: 'Ok',
          },
        ],
        duration: 3000,
        color: 'danger',
        position: 'bottom',
      });
      await toast.present();
      return;
    }

    let h = moment(this.start.value).format('HH');
    let m = moment(this.start.value).format('mm');
    let start_d = moment(this.date_picker).format('YYYY-MM-DD');
    start_d = `${start_d}T${h}:${m}`;
    let start_f = moment(start_d).toDate();

    let eh = moment(this.end.value).format('HH');
    let em = moment(this.end.value).format('mm');
    let end_d = moment(this.date_picker).format('YYYY-MM-DD');
    end_d = `${end_d}T${eh}:${em}`;
    let end_f = moment(end_d).toDate();

    this.start.setValue(start_f);
    this.end.setValue(end_f);

    let time_checker_start = moment(start_f).format('YYYY-MM-DDTHH:mm:ssZ');
    let time_checker_end = moment(end_f).format('YYYY-MM-DDTHH:mm:ssZ');
    let early_time_picker = this.early.value
      ? moment(this.early.value).format('YYYY-MM-DDTHH:mm:ssZ')
      : null;
    let report_time_picker = this.report_time.value
      ? moment(this.report_time.value).format('YYYY-MM-DDTHH:mm:ssZ')
      : null;
    let departure_time_picker = moment(this.departure.value).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );
    let return_time_picker = moment(this.return_time.value).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );

    let d = moment(this.date_picker).format('YYYY-MM-DD');
    // let h = moment(new Date()).format('HH');
    // let m = moment(new Date()).format('mm');
    let current = `${d}T12:00`;
    const date_with_time_to_save = moment(current).format(
      'YYYY-MM-DDTHH:mm:ssZ',
    );

    const ids = this.selectedReferees?.map((item) => item.id);
    const emails = this.selectedReferees?.map((item) => item.email);
    let origin = window.location.origin;

    // The FIRST-ADDED AD stays in the legacy single-AD fields for backward
    // compatibility (the list displays latest first, so it is the last element)
    const primary_opposing_ad =
      this.selectedOpposingAds[this.selectedOpposingAds.length - 1] || null;
    const opposing_ads_payload = this.selectedOpposingAds.map((a) => ({
      id: a.id,
      name: a.name,
      email: a.email,
      number: a.number,
      opposing_team_id: a.opposing_team_id || null,
      opposing_team_name: a.opposing_team_name || null,
    }));

    let field_event: field_event = {
      your_club_id: data.high_school?.name ? data.high_school.id : null,
      club_name: data.high_school?.name || null,
      for_referee: data.for_referee,
      high_school_id: data.selected_high_school?.name ? data.selected_high_school.id : null,
      high_school_name: data.selected_high_school?.name || null,
      your_team_id: data.teaming_up_group_id.id,
      your_team_title: data.teaming_up_group_id.title,
      opposing_team_id:
        primary_opposing_ad?.opposing_team_id ||
        data.opposing_teaming_up_group_id?.id,
      governing_organization: data.governing_organization,
      sport_id: data.sport_json.id,
      field_event_type: data.type,
      date_of_game_event: date_with_time_to_save,
      start_time: time_checker_start,
      end_time: time_checker_end,
      early_time: early_time_picker,
      report_time: report_time_picker,
      departure: data.bus ? departure_time_picker : null,
      return_time: data.bus ? return_time_picker : null,
      game_type: data.game_type,
      away_field_address: data.field_address,
      opposing_team_name:
        primary_opposing_ad?.opposing_team_name || data?.opposing_team,
      opposing_ad_id: primary_opposing_ad?.id,
      opposing_ads: opposing_ads_payload,
      ...this.busServicesPayload(data.bus),
      need_game_contract: data.need_game_contract,
      need_referees_assigned: data.need_referees_assigned,
      fee_per_referee: data.fees_referee ? data.fees_referee : null,
      need_bus: data.bus,
      field_id: data.field_facility?.id,
      field_name: data.field_facility?.label,
      description: data.description,
      referee_contact_ids: ids,
      referee_contact_emails: emails,
      referees: this.selectedReferees,
      
      event_staff_contacts: this.selectedEventStaff,
      opposing_ad: primary_opposing_ad,
      sport_name: data.sport_json?.name,
      origin: origin,
      id: this.selected_schedule?.id,
      send_updates_to_referees: this.send_updates_to_referees,
      send_updates_to_opposing_ad: this.send_updates_to_opposing_ad,
      send_updates_to_bus_service: this.send_updates_to_bus_service,
      send_updates_to_staff: this.send_updates_to_staff,
    };

    if (this.selected_schedule?.id) {
      let depChanged = false;
      let retChanged = false;

      if (data.bus) {
        let origDep = this.selected_schedule.departure;
        if (!origDep) {
          depChanged = true;
        } else {
          if (moment(origDep).format('HH:mm') !== moment(departure_time_picker).format('HH:mm')) {
            depChanged = true;
          }
        }

        let origRet = this.selected_schedule.return_time;
        if (!origRet) {
          retChanged = true;
        } else {
          if (moment(origRet).format('HH:mm') !== moment(return_time_picker).format('HH:mm')) {
            retChanged = true;
          }
        }
      }

      // Added buses and per-bus count changes are notified per bus by the backend;
      // only shared trip changes re-send to every bus.
      let needBusChanged = !!data.bus != !!this.selected_schedule.need_bus;

      if (depChanged || retChanged || needBusChanged) {
        field_event.send_updates_to_bus_service = true;
      }

      field_event.ad_signature = this.selected_schedule?.ad_signature;
      field_event.is_ad_confirmed = this.selected_schedule?.is_ad_confirmed;
      field_event.bus_service_signature =
        this.selected_schedule?.bus_service_signature;
      field_event.is_bus_confirmed = this.selected_schedule?.is_bus_confirmed;
      field_event.home_event_id = this.selected_schedule?.home_event_id;
      field_event.opposing_ad_event_id =
        this.selected_schedule?.opposing_ad_event_id;
    }

    if (
      moment(this.end.value).isSameOrBefore(this.start.value, 'minutes') ||
      moment(time_checker_end).isSameOrBefore(time_checker_start, 'minutes')
    ) {
      const t = await this.toast.create({
        message:
          'End time cannot be before start time. Please adjust and try again',
        buttons: [
          {
            role: 'cancel',
            text: 'Ok',
          },
        ],
        duration: 3000,
        color: 'warning',
        position: 'bottom',
      });
      await t.present();
    } else {
      this.selectedAccount = localStorage.getItem('selected_account');
      this.ad_admin_email = localStorage.getItem('ad_admin_email');
      this.ad_admin_id = localStorage.getItem('ad_admin_id');

      // Check if this is from pending schedule - if so, always use create call and include league_scheduler_event_id
      if (this.openSource === 'from-pending') {
        // Add league_scheduler_event_id from the selected schedule for pending schedule items
        field_event.league_scheduler_event_id = this.selected_schedule?.id;
        // Always use create for pending schedule items
        this.bll.create_new_field_event(
          field_event,
          this.selectedAccount == '2'
            ? {
                ad_admin_id: this.ad_admin_id,
                ad_admin_email: this.ad_admin_email,
              }
            : null,
        );
      } else if (this.selected_schedule?.id) {
        field_event.league_scheduler_id = this.form.get('league_schedule_id').value || null;

        this.bll.update_field_event(
          field_event,
          this.selectedAccount == '2'
            ? {
                ad_admin_id: this.ad_admin_id,
                ad_admin_email: this.ad_admin_email,
              }
            : null,
        );
      } else {
        field_event.league_scheduler_id = this.form.get('league_schedule_id').value || null;

        this.bll.create_new_field_event(
          field_event,
          this.selectedAccount == '2'
            ? {
                ad_admin_id: this.ad_admin_id,
                ad_admin_email: this.ad_admin_email,
              }
            : null,
        );
      }
      this.reset_form_and_bll();
      this.edit_field_event_overlay = false;
    }
  }

  //#region FORM GETTERS

  get governing_organization() {
    return this.form.get('governing_organization');
  }

  get high_school() {
    return this.form.get('high_school');
  }

  get teaming_up_group_id() {
    return this.form.get('teaming_up_group_id');
  }

  get opposing_teaming_up_group_id() {
    return this.form.get('opposing_teaming_up_group_id');
  }

  get start() {
    return this.form.get('start');
  }

  get end() {
    return this.form.get('end');
  }

  get early() {
    return this.form.get('early');
  }

  get report_time() {
    return this.form.get('report_time');
  }

  get departure() {
    return this.form.get('departure');
  }

  get return_time() {
    return this.form.get('return_time');
  }

  get type() {
    return this.form.get('type');
  }

  get game_type() {
    return this.form.get('game_type');
  }

  get keyword_team() {
    return this.form.get('keyword_team');
  }

  get keyword_opposing_team() {
    return this.form.get('keyword_opposing_team');
  }

  get for_referees(){
    return this.form.get('for_referees');
  }

  change_high_school_overlay(show: boolean) {
    this.show_high_school_overlay = show;
    if (show) {
      if (this.high_school_name_search?.length > 1) {
        this.currentSportsBLL.get_current_schools_email(this.high_school_name_search, 'new-league');
      }
    } else {
      this.currentSportsBLL.clear_high_schools();
    }
  }

  onHighSchoolSearchInput() {
    if (this.high_school_name_search?.length > 1) {
      // Small delay for debounce
      setTimeout(() => {
        this.currentSportsBLL.get_current_schools_email(this.high_school_name_search, 'new-league');
      }, 150);
    }
  }

  selectHighSchool(school: any) {
    this.show_high_school_overlay = false;
    this.high_school_name_search = school.name || school.school;
    this.form.get('selected_high_school').setValue(school);
    this.currentSportsBLL.clear_high_schools();

    // Mutual exclusivity: clear club
    this.clearClub();
  }

  clearHighSchool() {
    this.high_school_name_search = '';
    this.form.get('selected_high_school').setValue(null);
    this.show_high_school_overlay = false;
    this.currentSportsBLL.clear_high_schools();
  }

  handleChangeSchool(event: any) {
    // If a club is selected from the original dropdown, clear the new high school field
    if (event.detail.value) {
      this.form.get('selected_high_school').setValue(null);
      this.high_school_name_search = '';
    }
  }

  change_club_overlay(show: boolean) { 
    this.show_club_overlay = show;
    if (show) {
      if (this.club_name_search?.length > 1) {
        this.bll.get_panda_clubs(this.club_name_search);
      }
    } else {
      this.bll.clear_panda_clubs();
    }
  }

  onClubSearchInput() {
    if (this.club_name_search?.length > 1) {
      setTimeout(() => {
        this.bll.get_panda_clubs(this.club_name_search);
      }, 150);
    }
  }

  selectClub(club: any) {
    this.show_club_overlay = false;
    this.club_name_search = club?.name || club?.school_name;
    this.form.get('high_school').setValue(club);
    this.bll.clear_panda_clubs();

    // Mutual exclusivity: clear high school
    this.clearHighSchool();
  }

  clearClub() {
    this.club_name_search = '';
    this.form.get('high_school').setValue(null);
    this.show_club_overlay = false;
    this.bll.clear_panda_clubs();
  }

  get sport_json() {
    return this.form.get('sport_json');
  }

  sports_id: string;
  field_id: string;

  get field_facility() {
    return this.form.get('field_facility');
  }

  get opposing_ad() {
    return this.form.get('opposing_ad');
  }

  get bus_service() {
    return this.form.get('bus_service');
  }

  get field_address() {
    return this.form.get('field_address');
  }

  get opposing_team() {
    return this.form.get('opposing_team');
  }

  get ad_name() {
    return this.form.get('ad_name');
  }

  get ad_email() {
    return this.form.get('ad_email');
  }

  get bus() {
    return this.form.get('bus');
  }

  get ad_cell() {
    return this.form.get('ad_cell');
  }

  get ref_org_name() {
    return this.form.get('ref_org_name');
  }

  get Ref_Org_email() {
    return this.form.get('Ref_Org_email');
  }

  get Ref_Org_mobile() {
    return this.form.get('Ref_Org_mobile');
  }

  get fees_referee() {
    return this.form.get('fees_referee');
  }

  get referee() {
    return this.form.get('referee');
  }

  get event_staff() {
    return this.form.get('event_staff');
  }

  handleChange(e) {
    this.sports_id = e.detail.value;
  }

  handleFacilityFieldChange(e) {
    this.field_id = e.detail.value;
  }

  club_id: string;

  async handleChangeAd(e) {
    const value = e.detail.value;
    if (value) {
      await this.addOpposingAd(value);
    }
    // The select is only a picker; the chosen ADs live in selectedOpposingAds
    this.opposing_ad.setValue(null, { emitEvent: false });
  }

  async addOpposingAd(contact: any, team: any = null) {
    if (!contact?.id) {
      return;
    }

    const alreadySelected = this.selectedOpposingAds.some(
      (a) => a.id === contact.id,
    );
    if (alreadySelected) {
      const t = await this.toast.create({
        message: `Opposing AD already selected.`,
        duration: 5000,
        color: 'warning',
      });
      await t.present();
      return;
    }

    const entry = {
      id: contact.id,
      name: contact.name || '',
      email: contact.email || '',
      number: contact.number || '',
      school: contact.school || '',
      opposing_team_id: team?.id || null,
      // No default: the user must explicitly pick the AD's team
      opposing_team_name: team?.title || '',
      // Drives the one-time entrance highlight on the card
      just_added: true,
    };

    // Latest selected AD shows first
    this.selectedOpposingAds.unshift(entry);
    if (this.activeOpposingAdIndex >= 0) {
      this.activeOpposingAdIndex++;
    }
    setTimeout(() => (entry.just_added = false), 1200);

    this.customSportAlertADOptions.message = 'Add More Opposing AD?';
    this.sync_primary_opposing_ad_fields();
  }

  removeOpposingAd(index: number): void {
    this.selectedOpposingAds.splice(index, 1);
    if (this.activeOpposingAdIndex === index) {
      this.activeOpposingAdIndex = -1;
      this.show_opposing_teams_overlay = false;
    } else if (this.activeOpposingAdIndex > index) {
      this.activeOpposingAdIndex--;
    }
    if (this.selectedOpposingAds.length === 0) {
      this.customSportAlertADOptions.message = 'Select One';
    }
    this.sync_primary_opposing_ad_fields();
  }

  // Legacy single-AD form controls keep mirroring the FIRST-ADDED opposing AD
  // (the list displays latest first, so that is the last element) so the
  // existing payload fields and change detection stay backward compatible.
  sync_primary_opposing_ad_fields() {
    const primary =
      this.selectedOpposingAds[this.selectedOpposingAds.length - 1] || null;
    this.ad_name?.setValue(primary?.name || '');
    this.ad_email?.setValue(primary?.email || '');
    this.ad_cell?.setValue(primary?.number || '');
    this.opposing_team?.setValue(primary?.opposing_team_name || '');
    this.selected_opposing_team = primary?.opposing_team_id
      ? { id: primary.opposing_team_id, title: primary.opposing_team_name }
      : null;
    this.opposing_teaming_up_group_id.setValue(
      this.selected_opposing_team || {},
    );
  }

  // Compare function for ion-select to match AD contacts by email
  compareAdContacts(o1: any, o2: any): boolean {
    if (!o1 || !o2) return false;
    return o1.email === o2.email;
  }

  openSelectOpposingAdModal(index: number) {
    const ad = this.selectedOpposingAds[index];
    if (ad?.email) {
      this.activeOpposingAdIndex = index;
      this.show_opposing_teams_overlay = true;
    } else {
      this.toast
        .create({
          message: 'This AD has no email on file, so their teams cannot be searched.',
          duration: 3000,
          color: 'warning',
        })
        .then((t) => t.present());
    }
  }

  selectedBuses = [];

  async handleChangeBusService(e) {
    const value = e.detail.value;
    if (value) {
      if (this.selectedBuses.some((b) => b.id === value.id)) {
        const t = await this.toast.create({
          message: `Bus service already selected.`,
          duration: 5000,
          color: 'warning',
        });
        await t.present();
      } else {
        this.addBusService(value);
      }
    }
    this.bus_service.setValue(null, { emitEvent: false });
  }

  addBusService(contact) {
    if (this.selectedBuses.some((b) => b.id === contact.id)) return;
    this.selectedBuses.push({ ...contact, buses_needed: contact.buses_needed || 1 });
    this.customSportAlertBusServiceOptions.message = 'Add More Bus Service?';
  }

  removeBusService(index: number): void {
    this.selectedBuses.splice(index, 1);
  }

  onNeedBusChange(checked: boolean) {
    if (!checked) {
      this.selectedBuses = [];
      this.bus_service.setValue(null, { emitEvent: false });
    }
  }

  busServiceStatus(bus): 'confirmed' | 'rejected' | 'pending' {
    if (bus?.is_bus_confirmed === true) return 'confirmed';
    if (bus?.is_bus_confirmed === false) return 'rejected';
    return 'pending';
  }

  // The first bus still fills the legacy single-bus fields for older readers
  busServicesPayload(need_bus: boolean) {
    const buses = need_bus ? this.selectedBuses : [];
    const primary = buses[0];
    return {
      bus_services: buses.map((b) => ({
        id: b.id,
        name: b.name,
        email: b.email,
        number: b.number,
        buses_needed: b.buses_needed,
      })),
      bus_service: primary || null,
      bus_service_id: primary?.id,
      buses_needed: primary?.buses_needed,
    };
  }

  selectedReferees = [];

  blocked_referees: { [contact_id: string]: string } = {};
  refresh_referee_availability() {
    const start = this.combine_date_and_time(this.start?.value);
    const end = this.combine_date_and_time(this.end?.value);

    if (!start || !end || end.isSameOrBefore(start)) {
      this.blocked_referees = {};
      return;
    }

    this.bll.check_referee_availability(
      start.toISOString(),
      end.toISOString(),
      this.selectedAccount == '2' ? this.ad_admin_id : null,     
      this.openSource === 'from-pending' ? null : this.selected_schedule?.id
    );
  }

  private combine_date_and_time(value: any): moment.Moment {
    if (!value) {
      return null;
    }
    const day = moment(this.date_picker ? this.date_picker : value).format('YYYY-MM-DD');
    return moment(`${day}T${moment(value).format('HH:mm')}`);
  }

  /**
   * Same-game conflict for a referee in the "Select Referee" list, or null.
   * The availability check ignores the game being edited, so these are caught
   * here (and again by the API on save):
   *  - already in this game's list (same contact, or another contact with the same email)
   *  - already given a slot by an Assigner on this game (pending or accepted)
   */
  sameGameRefereeConflict(referee: any): string | null {
    const email = (referee?.email || '').trim().toLowerCase();

    for (const selected of this.selectedReferees || []) {
      const selectedEmail = (selected?.email || '').trim().toLowerCase();
      if (selected?.id === referee?.id || (email && selectedEmail === email)) {
        return 'Already on this game';
      }
    }

    if (!email) {
      return null;
    }

    for (const selected of this.selectedReferees || []) {
      const hit = (selected?.assigned_referees || []).find(
        (a: any) => (a?.email || '').trim().toLowerCase() === email && a?.status !== 'rejected'
      );
      if (hit) {
        const state = hit.status === 'completed' ? 'accepted' : 'pending';
        return `Already assigned by ${selected?.name || 'an assigner'} (${state})`;
      }
    }

    return null;
  }

  async handleChangeReferee(e) {
    const value = e.detail.value;

    if (value) {
      if (this.blocked_referees[value.id]) {
        const t = await this.toast.create({
          message: `${value.name} is unavailable at this date and time and cannot be assigned. ${this.blocked_referees[value.id]}`,
          duration: 5000,
          color: 'warning',
        });
        await t.present();
        this.referee.setValue(null);
        return;
      }

      const conflict = this.sameGameRefereeConflict(value);
      if (conflict) {
        const t = await this.toast.create({
          message: `${value.name} cannot be added: ${conflict.toLowerCase()}.`,
          duration: 5000,
          color: 'warning',
        });
        await t.present();
      } else {
         value.refs_needed = 1;
        // value.refs_needed = this.for_referee ? 1 : (value.refs_needed || 1);
        // this.selectedReferees.push({
        //   ...value,
        //   refs_needed: value.refs_needed,
        // });
        this.selectedReferees.push(e.detail.value);
        this.customAlertRefereeOptions.message = 'Add More Referee?';
      }
    }

    this.referee.setValue(null, {emitEvent: false});
  }

  handleGameTypeChange(e) {
    if (e == 'away') {
      this.field_facility.setValue(null);
      // this.bus.setValue(true);
    } else {
      this.field_address.setValue('');
    }
  }

  /**
   * Label for a referee option in the "Select Referee" alert:
   * "Name (Role) - Sports Officiated" (the sports part only when set).
   * Mirrors the Referee Contacts list, where a contact without a PANDA
   * account has no user_role and is shown as "Not a PANDA user".
   * The alert renders plain text, so the sports go on the same line.
   */
  refereeOptionLabel(referee: any): string {
    const name = referee?.name || '';
    const rawRole = referee?.user_role;
    const role = rawRole
      ? String(rawRole)
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : 'Not a PANDA user';
    const label = name ? `${name} (${role})` : role;
    const sports = (referee?.sports_officiated || '').trim();
    return sports ? `${label} - ${sports}` : label;
  }

  removeReferee(index: any): void {
    this.selectedReferees.splice(index, 1);
  }

  // ---------------------------------------------------------------------------
  // Refs Needed > 1: popup listing the sub-referees this referee / referee
  // organization assigned (backend: referee_contacts[].assigned_referees).
  // ---------------------------------------------------------------------------
  show_assigned_refs_modal = false;
  assigned_refs_referee: any = null;

  openAssignedRefs(referee: any): void {
    this.assigned_refs_referee = referee;
    this.show_assigned_refs_modal = true;
  }

  closeAssignedRefs(): void {
    this.show_assigned_refs_modal = false;
    this.assigned_refs_referee = null;
  }

  /** Same badges as Manage Referee Assignment (pending / completed / not joined / rejected). */
  assignedRefStatus(row: any): RefereeStatus {
    return getRefereeStatus(row);
  }

  refereeStatus(referee: any): 'accepted' | 'rejected' | 'pending' {
    if (referee?.confirmed === true) {
      return 'accepted';
    }
    if (referee?.confirmed === false) {
      return 'rejected';
    }
    return 'pending';
  }

  selectedEventStaff = [];

  // Tracks which staff rows have the role input open
  staffRoleEditMode: { [index: number]: boolean } = {};

  onNeedEventStaffChange(checked: boolean) {
    if (!checked) {
      this.selectedEventStaff = [];
      this.staffRoleEditMode = {};
      this.form.get('event_staff').setValue(null);
    }
  }

  async handleChangeEventStaff(e) {
    const value = e.detail.value;

    if (value) {
      const alreadySelected = this.selectedEventStaff.some((s) => s.id === value.id);
      if (alreadySelected) {
        const t = await this.toast.create({
          message: `Event staff already selected.`,
          duration: 5000,
          color: 'warning',
        });
        await t.present();
      } else {
        this.selectedEventStaff.push(value);
        this.customAlertEventStaffOptions.message = 'Add More Event Staff?';
      }
    }

    this.form.get('event_staff').setValue(null);
  }

  toggleStaffRoleEdit(index: number): void {
    this.staffRoleEditMode[index] = !this.staffRoleEditMode[index];
  }

  onStaffRoleInput(index: number, value: string): void {
    this.selectedEventStaff[index].staff_role = value;
  }

  removeEventStaff(index: number): void {
    this.selectedEventStaff.splice(index, 1);
    // Re-index the edit mode map
    const updated: { [key: number]: boolean } = {};
    Object.keys(this.staffRoleEditMode).forEach((k) => {
      const num = parseInt(k, 10);
      if (num < index) {
        updated[num] = this.staffRoleEditMode[num];
      } else if (num > index) {
        updated[num - 1] = this.staffRoleEditMode[num];
      }
    });
    this.staffRoleEditMode = updated;
  }

  stringifySchools(sch) {
    return JSON.stringify(sch);
  }

  openAddFacilityFieldModal() {
    this.fieldFacilityBLL.toggleAddFacilityModel(true);
  }

  openAddBusContactModal() {
    this.busContactsBLL.toggleAddContactModel(true);
  }

  openADContactModal() {
    this.adContactsBll.toggleAddContactModel(true);
  }

  openRefereeContactModal() {
    this.refereeContactBll.toggleAddContactModel(true);
  }

  openEventStaffContactModal() {
    this.eventStaffContactBll.toggleAddContactModel(true);
  }
}
